import gb from './GB.png';
import bd from './BD.png';

export const FLAG_SRC = {
  en: gb,
  bn: bd,
};
